export enum OriginalSupplyActions {
  FETCH_MACHINES = "FETCH_MACHINES",
  FETCH_MACHINES_START = "FETCH_MACHINES_START",
  FETCH_MACHINES_SUCCESS = "FETCH_MACHINES_SUCCESS",
  FETCH_MACHINES_FAIL = "FETCH_MACHINES_FAIL"
}
